// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1P-Dw","row":"styles_row__2Dvzo"};